import { Component } from '@angular/core';
import { NavController, AlertController, ToastController } from 'ionic-angular';

import { GlobalVars } from '../../app/app.vars';

import { Admin } from '../admin/admin';
import { Admin1b } from '../admin1b/admin1b';

@Component({
  selector: 'page-admin1a',
  templateUrl: 'admin1a.html'
})
export class Admin1a {
  
  gauge: any;
  pressureLimits: any;
  altitudeRange: any;
  idealPressure: any;

  constructor(public navCtrl: NavController, private alertCtrl: AlertController, private toastCtrl: ToastController, public globalVars: GlobalVars) {
  }

  ionViewDidEnter() {
    console.log('admin 1a');

    let obj = this.globalVars.getGlobalVar();

    this.gauge = obj.idealPressure; // this.getRandom(obj.pressureMin, obj.pressureMax);

    this.addLabel();

    let toast = this.toastCtrl.create({
      message: "Prior to the patient swallowing the capsule, reconfirm the Digital Gauge is stable. Refer to the label on the Obalon EzFill Dispenser for the expected pressure range.",
      position: 'middle',
      dismissOnPageChange: true
    });

    toast.onDidDismiss(() => {
    });

    setTimeout(() => {
    //  toast.present();
    }, 1000);
  }

  getRandom(min, max) {
    return (Math.random() * (max - min) + min).toFixed(1);
  }

  addLabel() {
    let obj = this.globalVars.getGlobalVar();

    this.pressureLimits = 'Pressure: ' + obj.pressureLimits + ' kPa';
    this.altitudeRange  = 'Operating Altitude: ' + obj.altitudeRange + ' ft';
    this.idealPressure  = 'City, State: Confirm Your Location';
  }

  ionViewWillLeave() {
  }

  prevPage = Admin;
  nextPage = Admin1b;

  openPage(page) {
    this.navCtrl.setRoot(page);
  }

  showAlertThenOpenPage(page) {
  	let alert = this.alertCtrl.create({
      message: 'CAUTION: DO NOT PROCEED with use of the EzFill Dispenser until you have verified that the gauge pressure is within the appropriate range and that the gauge pressure is stable.',
      buttons: [{
	    text: 'Ok',
	    handler: () => {
	      // user has clicked the alert button
	      // begin the alert's dismiss transition
	      let navTransition = alert.dismiss();

	      navTransition.then(() => {
	        this.navCtrl.setRoot(page);
	      });
	
	      return false;
	    }
	  }],
      enableBackdropDismiss: false
    });
    alert.present();
  }
}